<template>
  <div>
    <div
      ref="scrollContainer"
      class="timeline-wrapper mt-3"
      @mousedown="onMouseDown"
      @mouseleave="onMouseLeave"
      @mousemove="onMouseMove"
      @mouseup="onMouseUp">

      <table v-show="!isLoading&&showPlanning&&this.operations" class="timeline backwhite">
        <thead>
        <tr ref="yearsRow">
          <th class="resource-name column-left action-button">
            <div class="row justify-content-center">
              <b-button class="small-button" size="xs" variant="outline-primary" @click="previousYear">
                <b-icon-arrow-left/>
              </b-button>
              <b-button class="small-button" size="xs" variant="outline-primary" @click="today('smooth')">
                Today
              </b-button>
              <b-button class="small-button" size="xs" variant="outline-primary" @click="nextYear">
                <b-icon-arrow-right/>
              </b-button>
            </div>
          </th>
          <th v-for="year in years" :key="year.toString()" :class="year.toString()" :colspan="12" class="year">{{
              year
            }}
          </th>
        </tr>
        <tr>
          <th class="resource-name resource-empty column-left">
          </th>
          <th v-for="month in months" :key="month.toString()" :class="{ 'current-month': isCurrentMonth(month) }"
              class="month">
            {{ format(month, 'MMM') }}
          </th>

        </tr>

        </thead>
        <tbody>
        <template v-if="operations && operations.length > 0">
          <template v-for="operation in this.operations">
            <tr :key="operation.id">
              <td class="resource-name resource-column column-left">
                <b-card v-b-toggle="'collapse-' + operation.id" class="td-bcard"
                        @click="toggleOperation(operation.id)">
                  <div class="d-flex align-items-center">
                    <img
                      :src='operation.picture ? getFileUrl(operation.picture.fileUrl) : require(`@/assets/images/APRILYOS/emptyState.png`)'
                      alt="Image Opération"
                      class="rounded-circle"
                      style="width: 60px; height: 60px; object-fit: cover">
                    <b-card-text :style="{ 'margin-left': '0.75em','min-width':'105px' }">
                      <div class="bold-text d-flex align-items-center">{{ operation.tostring }}</div>
                    </b-card-text>
                    <b-icon
                      :icon="visibleOperations.includes(operation.id) ? 'chevron-down' : 'chevron-right'"
                      class="ml-auto"
                      font-scale="1.5"
                      shift-h="-4"
                    ></b-icon>
                  </div>
                </b-card>
              </td>
              <td v-for="month in months" :key="month.toString() + operation.id"
                  :class="{ 'current-month': isCurrentMonth(month), 'past-month': isPastMonth(month) }"
                  :style="{ '--current-day-percentage': currentDayOfMonthPercentage() + '%' }"
                  class="month">
                <div v-for="event in filteredEvents(operation.id, month)" :id="'event' + event.id"
                     :key="event.id" class="event">
                  <Evenement :evenement-type="evenementType" :event="event" :month="month"/>
                </div>
              </td>
            </tr>
            <tr v-for="lot in operation.operationLots" v-if="visibleOperations.includes(operation.id)" :key="lot.id">
              <td class="resource-name resource-column lot column-left">
                <b-card class="mb-3 td-bcard">
                  <div class="d-flex align-items-center">
                    <b-card-text class="ml-2">
                      <div :style="{ 'margin-left': '2.5em' }" class="bold-text">{{ lot.tostring }}</div>
                    </b-card-text>
                  </div>
                </b-card>
              </td>
              <td v-for="month in months" :key="month.toString() + lot.id"
                  :class="{ 'current-month': isCurrentMonth(month), 'past-month': isPastMonth(month) }"
                  :style="{ '--current-day-percentage': currentDayOfMonthPercentage() + '%' }"
                  class="month">
                <div v-for="event in filteredEvents(lot.id, month, false)" :id="'event' + event.id"
                     :key="event.id" class="event"
                >
                  <Evenement :evenement-type="evenementType" :event="event"
                             :month="month"/>
                </div>
              </td>
            </tr>
          </template>
        </template>
        <template v-else>
          <tr>
            <td class="resource-name resource-empty column-left"></td>
            <td v-for="month in months" :key="month.toString()" class="month"></td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div v-show="isLoading && !showPlanning " class="spinner-planning">
      <b-spinner label="Loading..." large></b-spinner>
    </div>
  </div>
</template>


<script>
import {
  startOfMonth,
  endOfMonth,
  differenceInDays,
  parseISO,
  format,
  isThisMonth,
  getYear,
  getMonth,
  getDaysInMonth
} from 'date-fns';
import {fr} from "date-fns/locale";
import api from "../../services/api";
import Evenement from './Evenement'

export default {

  name: "OperationPlanning",
  components: {
    Evenement
  },
  props: {
    operations: {
      type: Array,
      default: []
    }
  },
  data() {

    return {
      currentMonthAndYear: new Date(),
      isLoading: true,
      eventSize: 40,
      currentDate: new Date(),
      years: [],
      months: [],
      items: [],
      dragging: false,
      startX: 0,
      scrollLeft: 0,
      targetDate: new Date(),
      hoveredEventId: null,
      evenementType: [],
      showPlanning: false,
      resetMonth: false,
      visibleOperations: []
    };
  },
  watch: {
    operations: {
      immediate: true,
      async handler(newValue) {
        await this.getTypesEvenements()
        this.initializeStartYear();
        this.today('auto');
        if (newValue && newValue.length === 1) {
          this.visibleOperations.push(newValue[0].id);
        }
      },
    },
  },
  computed: {},
  async mounted() {
    if (this.operations.length > 0) {
      await this.getTypesEvenements()
      this.today('auto');
    }
  },

  methods: {

    toggleOperation(operationId) {
      const index = this.visibleOperations.indexOf(operationId);
      if (index === -1) {
        this.visibleOperations.push(operationId);
      } else {
        this.visibleOperations.splice(index, 1);
      }
    },
    addYears(yearCount) {
      const lastYear = this.years[this.years.length - 1];

      for (let year = lastYear + 1; year <= lastYear + yearCount; year++) {
        this.years.push(year);
        for (let month = 0; month < 12; month++) {
          this.months.push(startOfMonth(new Date(year, month)));
        }
      }
    },

    initializeStartYear() {
      const allEvents = this.getAllEvents();

      let startYear, endYear;

      if (allEvents.length > 0) {
        const validEvents = allEvents.filter(event => event.startEvent !== null);
        if (validEvents.length > 0) {
          const earliestEvent = validEvents.reduce((prev, current) => new Date(prev.startEvent) < new Date(current.startEvent) ? prev : current);
          const latestEvent = validEvents.reduce((prev, current) => {
            const prevDate = prev.endEvent ? new Date(prev.endEvent) : new Date(prev.startEvent);
            const currentDate = current.endEvent ? new Date(current.endEvent) : new Date(current.startEvent);
            return prevDate > currentDate ? prev : current;
          });

          startYear = new Date(earliestEvent.startEvent).getFullYear();
          endYear = (latestEvent.endEvent ? new Date(latestEvent.endEvent) : new Date(latestEvent.startEvent)).getFullYear();
        } else {
          const currentYear = new Date().getFullYear();
          startYear = currentYear - 1;
          endYear = currentYear + 1;
        }
      } else {
        const currentYear = new Date().getFullYear();
        startYear = currentYear - 1;
        endYear = currentYear + 1;
      }

      const years = [];
      const months = [];
      for (let year = startYear; year <= endYear; year++) {
        years.push(year);
        for (let month = 0; month < 12; month++) {
          months.push(startOfMonth(new Date(year, month)));
        }
      }
      this.years = years;
      this.months = months;
    },
    getAllEvents() {
      let events = [];

      this.operations.forEach(operation => {
        events.push(...operation.evenements.filter(event => event.startEvent !== null));

        operation.operationLots.forEach(operationLot => {
          events.push(...operationLot.evenements.filter(event => event.startEvent !== null));
        });
      });

      return events;
    },


    async getTypesEvenements() {
      await api
        .get(`/evenementPlanning/getEvenementTypes`)
        .then(response => {
          this.evenementType = response.data
        })
    },

    currentDayOfMonthPercentage() {
      const now = new Date();
      const dayOfMonth = now.getDate();
      const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      return (dayOfMonth / daysInMonth) * 100;
    },


    isPastMonth(month) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
      return now > lastDayOfMonth;
    },


    async fetchEvenements(operationId) {
      await api.get('/operation/getEvenementsPlanning/' + operationId).then((response) => {
        response.data.forEach((item) => {
          this.items.push(item)
        })
      });
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    isCurrentMonth(month) {
      const paramsMonth = new Date(month)
      const currentMonth = new Date(this.currentMonthAndYear)
      return paramsMonth.getMonth() === currentMonth.getMonth() && paramsMonth.getFullYear() === currentMonth.getFullYear();
    },

    format(date, formatStr) {
      return format(date, formatStr, {locale: fr});
    },

    filteredEvents(id, month, isOperation = true) {
      let events = [];

      if (isOperation) {
        const operation = this.operations.find(operation => operation.id === id);
        if (operation) {
          events = operation.evenements;
        }
      } else {
        const operationWithLot = this.operations.find(operation =>
          operation.operationLots.some(lot => lot.id === id)
        );

        if (operationWithLot) {
          const lot = operationWithLot.operationLots.find(lot => lot.id === id);
          events = lot.evenements;
        }
      }
      if (events === undefined) {
        events = []
      }


      return events.filter(event => {
        if (event.startEvent == null) {
          return false
        }
        const eventStartDate = new Date(event.startEvent);
        const eventStartMonth = eventStartDate.getMonth();
        const eventStartYear = eventStartDate.getFullYear();

        return eventStartMonth === month.getMonth() && eventStartYear === month.getFullYear();
      });
    },


    onMouseDown(e) {
      this.dragging = true;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
    },
    onMouseLeave() {
      this.dragging = false;
    },
    onMouseUp() {
      this.dragging = false;
      this.checkScrollPosition();
    },
    onMouseMove(e) {
      if (!this.dragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walkX = (x - this.startX);
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walkX;
      this.checkScrollPosition();
    },

    checkScrollPosition() {
      const scrollContainer = this.$refs.scrollContainer;
      const nearBottom = scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.offsetWidth - 500;
      if (nearBottom) {
        this.addYears(1);
      }
    },

    today(behavior) {
      this.targetDate = new Date(); // Met à jour targetDate pour être la date actuelle
      this.$nextTick(() => {
        this.updateScroll(behavior);
        this.showPlanning = true;
        this.isLoading = false
      });
    },


    nextYear() {
      this.targetDate.setFullYear(this.targetDate.getFullYear() + 1);
      const nextYear = this.targetDate.getFullYear()
      const alreadyExists = this.years.includes(nextYear);
      if (!alreadyExists) {
        this.addYears(1)
      }
      this.targetDate.setMonth(0)
      this.resetMonth = true;
      this.updateScroll('smooth');
    },

    previousYear() {
      this.targetDate.setFullYear(this.targetDate.getFullYear() - 1);
      this.targetDate.setMonth(0)
      this.resetMonth = true;
      this.updateScroll('smooth');
    },

    updateScroll(behavior) {
      if (this.resetMonth) {
        this.targetDate.setMonth(0);
      }
      const currentYear = this.targetDate.getFullYear();
      const currentMonth = this.targetDate.getMonth();
      const startMonthIndex = this.months.findIndex(
        (month) => getYear(month) === currentYear && getMonth(month) === currentMonth
      );
      let targetMonthIndex = !this.resetMonth ? startMonthIndex - 2 : startMonthIndex
      if (targetMonthIndex >= 0) {
        this.$refs.scrollContainer.scrollTo({
          left: targetMonthIndex * 100,
          behavior: behavior
        });
      }
    },

  },
};
</script>


<style scoped>
@import '../../assets/css/timeline.css';

.backwhite {
  background-color: #FFFFFF;
}

tr:nth-child(2n) td.resource-name,
tr:nth-child(2n) td.resource-name > .td-bcard,
tr:nth-child(2n) td.month,
tr:nth-child(2n) td.current-month::before {
  background-color: #eaedf4 !important;
}
</style>





// WEBPACK FOOTER //
// src/views/operationPlanning/OperationPlanning.vue